export const externalLinks = {
  utm: {
    source: 'VolunteerCenter',
    campaign: 'MLP',
  },
  volunteeringGrants: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/Grants/',
  attendance: {
    becomeAmbassador:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/BecomeACommunityAmbassador/',
    workdocs:
      'https://amazon.awsapps.com/workdocs-amazon/index.html#/folder/96bc12d73ade87046b612bce18be243f3747fd659a2cf288bd41252ad2a31ed9',
  },
  myActivity: {
    search: 'https://www.volunteercenter.amazon.dev/',
    wiki: {
      planEvent: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/PlanAnEvent',
      manageEvent:
        'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/ManageYourEvent',
      amazonVolunteering: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering',
      playbooks:
        'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/VolunteeringPlaybooks',
    },
    givehub: {
      charitableOrgs: 'https://amazon.benevity.org/search/causes/list',
    },
    training: {
      coordinatorTraining: 'https://atoz.amazon.work/learn/trainings/CRSKN1T201908301943090c891045',
    },
    dashboard: {
      eventSearch:
        'https://us-east-1.quicksight.aws.amazon.com/sn/account/amazonbi/dashboards/a8690998-94a5-4053-9f51-8aa0c28e5a3c/sheets/a8690998-94a5-4053-9f51-8aa0c28e5a3c_2677723d-6bec-47d5-89b2-5f6b5f776995',
    },
  },
  moreWays: {
    planEvent:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/EE/Volunteering/PlanningaVolunteerEvent/',
    plugAndPlay:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/EE/Volunteering/PlanningintheUS/#HPlugandPlay',
    assistedPlanning:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/EE/Volunteering/PlanningintheUS/#HAssistedPlanning',
  },
  support: {
    becomeAmbassador:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/BecomeACommunityAmbassador/',
    documentation:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Tech/VolunteerCenter/UserGuide/',
    feature: 'https://sim.amazon.com/issues/create?template=4e30685d-c924-4864-b400-adfa8f86a9a1',
    whatsNewFeedback:
      'https://sim.amazon.com/issues/create?template=ac373807-1eeb-4678-ab10-bae932220346',
    contact:
      'https://river.amazon.com/workflow/run/wfss-de13faab-7604-4231-be3d-bee7ed112b09?buildingType=ACI',
    whoCanAccess:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Data/Projects/VolunteeringDataProducts/VolunteerCenter/FAQs#HWhohasaccesstoVolunteerCenter3F',
    givehubTutorials: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/EE/GIVEhub/Tutorials/',
    aciWiki: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering',
    vcWiki: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/EE/VolunteerCenter',
    planningPlaybooks:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/PlanAnEvent',
    training:
      'https://knet.csod.com/ui/lms-learning-details/app/curriculum/31929310-981f-425f-8688-e1ea1b2ddf3a',
    a2z: 'https://news.a2z.com/channels/1303470',
    hiring: 'https://amazon.jobs/content/en/internal/teams/ccr/aci',
    trackTime: 'https://amazon.benevity.org/volunteer/external/track',
    faqs: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/FAQs/',
    question:
      'https://river.amazon.com/LHR16/workflows?buildingType=ACI&q0=e15964d7-3055-4332-ae26-6f2391ec4e65&id=e15964d7-3055-4332-ae26-6f2391ec4e65',
    ticket: 'https://t.corp.amazon.com/create/templates/132ba58d-4ce0-41d9-8d45-5d2e5169f225',
    // The English translation report, which every language links to for now. utils/translationFeedback
    // maps each language to its own link, so a language can be given one written in it.
    reportTranslationEnUs:
      'https://sim.amazon.com/issues/create?assignedFolder=f9bb9bac-4807-4a2e-b691-4d10ae7dcf85&title=VC+Customer+Issue%3A+Report+a+translation&description=Volunteer+Center+is+written+in+English+first%2C+then+translated+into+other+languages.+Translations+can+sometimes+be+wrong%2C+awkward%2C+or+missing+context.+If+you+see+one+that+doesn%27t+read+right%2C+tell+us+below+and+we%27ll+fix+it.%0A%0A**Please+note%3A**+Only+report+text+that+has+been+translated+incorrectly.+If+you+see+text+that+is+still+in+English+and+hasn%27t+been+translated+at+all%2C+you+don%27t+need+to+report+it.+We+already+know+about+it.+For+example%2C+event+content+like+title+and+description+as+entered+by+users+and+intentionally+not+translated.%0A%0A---%0A%0A%23%23%23+1.+Where+did+you+see+it%3F%0A%0A**Language%3A**%0AThe+language+you+were+viewing+Volunteer+Center+in.+Example%3A+Spanish+%28Mexico%29%2C+French+%28Canada%29%2C+Japanese%0A%5Blanguage%5D%0A%0A**Page+link+%28URL%29%3A**%0ACopy+the+url+from+the+top+of+your+browser+and+paste+it+here.%0A%5Bpaste+link+here%5D%0A%0A---%0A%0A%23%23%23+2.+What%27s+wrong%3F%0A%0A**The+translation+you+saw%3A**%0ACopy+and+paste+the+exact+words+if+you+can.%0A%5Bincorrect+translation%5D%0A%0A**What+it+should+say%3A**%0AYour+suggested+correct+translation.%0A%5Bcorrect+translation%5D%0A%0A**Why+it%27s+wrong+%28optional%29%3A**%0AExample%3A+%22wrong+meaning%22%2C+%22too+formal%22%2C+%22grammar+mistake%22%2C+%22cut+off%22%0A%5Breason%5D%0A%0AFound+more+than+one%3F+Copy+section+2+and+fill+out+for+every+translation+issue%0A%0A---%0A%0A%23%23%23+3.+Screenshot+%28optional%2C+but+very+helpful%29%0A%0AIf+you+can%2C+attach+a+screenshot+showing+the+text+on+the+page.+It+helps+us+find+and+fix+the+issue+faster.%0A%0A---%0A%0AThank+you%21+We+review+translation+reports+and+will+update+this+ticket+when+the+fix+is+live.&descriptionContentType=text%2Famz-markdown-sim&assigneeIdentity=email-alias%3A13e9ee0b-07be-401c-9408-300908643047&extensions%5Btt%5D%5Bcategory%5D=ACI&extensions%5Btt%5D%5Btype%5D=Tech&extensions%5Btt%5D%5Bitem%5D=Volunteer+Center+-+Customer+Issue&extensions%5Btt%5D%5BassignedGroup%5D=aitc-tech&extensions%5Btt%5D%5BcaseType%5D=Trouble+Ticket&extensions%5Btt%5D%5Basin%5D=&extensions%5Btt%5D%5Bimpact%5D=3&authorizations%5B%5D=role%3AFRONTLINE_GROUP%3A5a0716bb-69aa-4857-b51e-8d748e2c40b0&authZCompression=v1',
  },
  benevity: {
    trackTime: 'https://amazon.benevity.org/volunteer/external/track',
    event: 'https://amazon.benevity.org/volunteer/',
    editEvent: 'https://amazon.benevity.org/volunteer/{id}/edit',
    manageSignups: 'https://amazon.benevity.org/volunteer/{id}/manage/signups',
    manageTime: 'https://amazon.benevity.org/volunteer/{id}/manage/submissions',
    bulkEmail: 'https://amazon.benevity.org/adm/bulk_email/create?node_id={id}',
    signup: 'https://amazon.benevity.org/volunteer/signup/',
  },
  bulkUpload: {
    bulkUpdateInstructions:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Tech/Hack-A-Thons/2023-Q4/BulkGIVEhubUpdates/#HUserGuide',
    bulkUpdateTroubleshooting:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Tech/Hack-A-Thons/2023-Q4/BulkGIVEhubUpdates/#HTroubleshooting',
    accessRequest:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Tech/Operations/TicketTemplates/#HBugReports',
  },
  events: {
    coordinatorNotificationUserGuide:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Data/Projects/VolunteeringDataProducts/VolunteerCenter/UserGuide/Notifications-Coordinator/',
  },
  sideNav: {
    searchNonprofits: 'https://amazon.benevity.org/search/causes/list/?page=1&query=*',
    userGuides:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Data/Projects/VolunteeringDataProducts/VolunteerCenter/UserGuide',
    planEvent: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/PlanAnEvent',
    fundingSupport: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/Grants/',
    acivDashboard:
      'https://us-east-1.quicksight.aws.amazon.com/sn/account/amazonbi/dashboards/a8690998-94a5-4053-9f51-8aa0c28e5a3c/sheets/a8690998-94a5-4053-9f51-8aa0c28e5a3c_2677723d-6bec-47d5-89b2-5f6b5f776995',
    vcWiki:
      'https://w.amazon.com/bin/view/AmazonInTheCommunity/Data/Projects/VolunteeringDataProducts/VolunteerCenter/',
    aciWiki: 'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering',
    a2zNews: 'https://atoz.amazon.work/feed/topics/7b398df8-7358-4ea1-59cb-ea23180fc859',
    newsletter: 'https://list.email.amazon.dev/lists/volunteer-center-interest@amazon.com',
  },
};
